import { defineComponent as _defineComponent } from 'vue'
import { watch } from 'vue';
// Can be replaced with native Vue Teleport when on Vue 3
import Teleport from 'vue2-teleport';

import { enableScroll } from '@/helpers/scroll-helper';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { storeToRefs } from 'pinia';
import { useRoutingStore } from '@/stores/pinia/useRoutingStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseModalNew',
  props: {
    closable: { type: Boolean, default: true },
    hasHeader: { type: Boolean, default: true },
    hasFooter: { type: Boolean },
    disableTeleport: { type: Boolean },
    backgroundColor: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'close', display: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const { activeRoute } = storeToRefs(useRoutingStore());





watch(activeRoute, () => {
	enableScroll();
	emit('close', false);
});

return { __sfc: true,activeRoute, emit, Teleport, faTimes }
}

})